if ($(".ego-c-powermanager").length) {
    let jsonFileUpdated;

    function file_get_contents(filename, callback) {
        fetch(filename)
            .then((resp) => resp.text())
            .then(callback);
    }

    function handleResponse(data) {
        data = JSON.parse(data);

        $(powerManagerImageData).each(function (i, obj) {
            let imageFileName = obj.fileName;

            let foundKey = data.findIndex(x => x.img === imageFileName);

            if (foundKey !== -1) {
                data[foundKey]["img"] = obj.filePath;
            }
        });

        jsonFileUpdated = data;
    }

    file_get_contents(powerManagerJSON, handleResponse);

    class ChervonConfigurator {
        static getConfig() {
            return jsonFileUpdated;
        }

        static getImagePath() {
            return '';
        }

        static isLoggedIn() {
            return !!(getCookie('__auth') && getCookie('__uid'));
        }

        static loginUser() {
            return window.location = "/account?from=" + encodeURIComponent(window.location.pathname);
        }

        // static dealerLead(email, first, last, company, state) {
        //     console.log(state);
        // }

        static async saveForLaterEmail(configName, email, first, last, company, zip, permission, dealer, siteState) {
            let emailID = "165457923723"; //This is the default US email ID

            switch (Shopify.locale) {
                case 'es':
                    emailID = "176962334390";
                    break;
                case 'fr':
                    emailID = "176961136647";
                    break;
            }

            return new Promise(function (resolve, reject) {
                let saveForLaterEmailArray = {
                    configName: configName,
                    email: email,
                    first: first,
                    last: last,
                    company: company,
                    zip: zip,
                    permission: permission,
                    dealer: dealer,
                    siteState: window.location.origin + window.location.pathname + siteState,
                    type: "power-manager",
                    hs_language: Shopify.locale,
                    page_uri: window.location.origin + window.location.pathname,
                    emailId: emailID,
                    country: country,
                    region: locationInfo.Region
                }

                if (first === "123456789") {
                    resolve(false);
                }

                $.ajax({
                    method: 'POST',
                    url: apiURL + "rest/all/V1/chervon/proxy/single-send-api/1",//this defaults to the EGO US Store View
                    data: JSON.stringify(saveForLaterEmailArray),
                    contentType: 'application/json'
                })
                    .done(function (data) {
                        window.dataLayer.push({
                            'event': 'powermanager_submit',
                            'powermanager_data': {
                                'configuration_name': configName,
                                'company_name': company,
                                'company_zip': zip,
                                'marketing_optin': permission,
                                'dealer': dealer
                            }
                        });

                        if (data.success) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    })
                    .fail(function (error) {
                        console.log("error");
                        console.log(error);
                        resolve(false);
                    });
            });
        }
    }

    $(document).ready(function () {
        window.$ = $;
        window.ChervonConfigurator = ChervonConfigurator;
        // window.modal = modal;

        $(document).ready(function () {
            $.getScript(powerManagerJS)
                .done(function (script, textStatus) {
                    console.log("Power Manager Successfully loaded");
                })
                .fail(function (jqxhr, settings, exception) {
                    errorNotify('EGO Commercial: Could not load the Power Manager Javascript');
                });
        })
    });
}